'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function () {
  var Snap = undefined;
  try {
    Snap = require('snapsvg-cjs');
  } finally {
    return Snap;
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-burger-menu/lib/snapsvgImporter.js
// module id = 30
// module chunks = 35783957827783 107818501498521 212839066777427